import Annotator from "./Annotator";
import annotatorReducer from "./store/AnnotatorSlice";

export { annotatorReducer };

export default Annotator;
